import type { TradesRequest } from "./contracts";

export function buildTradesSearchParams(request: TradesRequest): URLSearchParams {
  const params = new URLSearchParams();
  if (request.deliveryDateFrom) params.set("deliveryDateFrom", request.deliveryDateFrom);
  if (request.deliveryDateTo) params.set("deliveryDateTo", request.deliveryDateTo);
  if (request.market) params.set("market", request.market);
  if (request.portfolioId) params.set("portfolioId", request.portfolioId);
  if (request.side) params.set("side", request.side);
  if (request.productCode) params.set("productCode", request.productCode);
  params.set("limit", String(request.limit));
  params.set("offset", String(request.offset));
  return params;
}

export const tradesQueryKeys = {
  portfolios: () => ["portfolios"] as const,
  list: (request: TradesRequest) =>
    ["trades", buildTradesSearchParams(request).toString()] as const,
};

export function buildTradesRequestPath(request: TradesRequest): string {
  return `/trades?${buildTradesSearchParams(request).toString()}`;
}
